// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.gridHorizontal__wnhn {
  display : grid;
  grid-template-columns: repeat(1, auto 1fr);
  grid-template-columns: repeat(var( --propertyGrid-columns, 1), auto 1fr);
  grid-column-gap : 16px;
  grid-column-gap : var( --size-propertyGridColumnGap, var( --size-padMedium, 16px ));
  -webkit-column-gap : 16px;
     -moz-column-gap : 16px;
          column-gap : 16px;
  -webkit-column-gap : var( --size-propertyGridColumnGap, var( --size-padMedium, 16px ));
     -moz-column-gap : var( --size-propertyGridColumnGap, var( --size-padMedium, 16px ));
          column-gap : var( --size-propertyGridColumnGap, var( --size-padMedium, 16px ));
  grid-row-gap : 16px;
  grid-row-gap : var( --size-propertyGridRowGap, var( --size-padMedium, 16px ));
  row-gap : 16px;
  row-gap : var( --size-propertyGridRowGap, var( --size-padMedium, 16px ));
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  justify-items: start;
  -webkit-box-pack: left;
      -ms-flex-pack: left;
          justify-content: left;
  padding : --size-padMedium, 16px;
  padding : var( --size-propertyGridPadding, --size-padMedium, 16px );
}

.gridVertical_Szvuz {
  display : grid;
  grid-template-columns: repeat(1, 1fr );
  grid-template-columns: repeat(var( --propertyGrid-columns, 1), 1fr );
  grid-column-gap : 16px;
  grid-column-gap : var( --size-propertyGridColumnGap, var( --size-padMedium, 16px ));
  -webkit-column-gap : 16px;
     -moz-column-gap : 16px;
          column-gap : 16px;
  -webkit-column-gap : var( --size-propertyGridColumnGap, var( --size-padMedium, 16px ));
     -moz-column-gap : var( --size-propertyGridColumnGap, var( --size-padMedium, 16px ));
          column-gap : var( --size-propertyGridColumnGap, var( --size-padMedium, 16px ));
  grid-row-gap : 24px;
  grid-row-gap : var( --size-propertyGridRowGap, var( --size-padLarge, 24px ));
  row-gap : 24px;
  row-gap : var( --size-propertyGridRowGap, var( --size-padLarge, 24px ));
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: start;
  justify-items: start;
  -webkit-box-pack: left;
      -ms-flex-pack: left;
          justify-content: left;
  padding : 16px;
  padding : var( --size-propertyGridPadding, var( --size-padMedium, 16px ));
}

.verticalCell_qBsf6 {
  display: inline-grid;
  grid-template-columns: auto;
  row-gap : 8px;
  row-gap : var( --propertyGridRowGap, var( --size-padSmall, 8px ));
}

.gridHorizontal__wnhn.inline_RioVJ, .gridVertical_Szvuz.inline_RioVJ {
  display : inline-grid;
}

.gridHorizontal__wnhn > .cell_pO5_k {
  grid-column-end : span 2;
  display: inline-block;
}
.gridVertical_Szvuz > .cell_pO5_k {
  grid-column-end : span 1;
  display: inline-block;
}


.gridHorizontal__wnhn > .fillCell_ExsE8 {
  grid-column-end : span 2;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.gridVertical_Szvuz > .fillCell_ExsE8 {
  grid-column-end : span 1;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  justify-self : stretch;
}

.fillCell_ExsE8 > *:nth-child(2) {
  margin-left : 16px;
  margin-left : var( --size-padMedium, 16px );
}

.newRow_ziTPz {
  grid-column-start: 1;
}

.gridHorizontal__wnhn > .stretch_qV3eb {
  display : grid;
  justify-self: stretch;
}

.gridVertical_Szvuz > .stretch_qV3eb {
  justify-self: stretch;
}


.gridHorizontal__wnhn > .fill_BFQjm, .gridHorizontal__wnhn > .header_nsuRL, .gridHorizontal__wnhn > .subheader_JyL8m {
  grid-column: 1 / span calc( 2 * 1 );
  grid-column: 1 / span calc( 2 * var( --propertyGrid-columns, 1) ); 
  display : grid;
  justify-self: stretch;
}

.gridVertical_Szvuz > .fill_BFQjm, .gridVertical_Szvuz > .header_nsuRL, .gridVertical_Szvuz > .subheader_JyL8m {
  grid-column: 1 / span 1;
  grid-column: 1 / span var( --propertyGrid-columns, 1); 
  display : grid;
  justify-self: stretch;
}

.inset_dRjPx {
  padding : 16px 0 16px 32px;
  padding : var( --size-padMedium, 16px ) 0 var( --size-padMedium, 16px ) var( --size-padXLarge, 32px );
}

.pad_N5y3N {
  padding : 16px;
  padding : var( --size-padLarge, 16px )
}

.gridVertical_Szvuz > .divider_Ncsrx {
  height : 2px;
  grid-column: 1 / span 1;
  grid-column: 1 / span var( --propertyGrid-columns, 1);
  background : #eeeeee;
  margin : 0 calc( 16px * -1);
  margin : 0 calc( var( --size-padMedium, 16px ) * -1);
  width: 100%;
}

.gridHorizontal__wnhn > .divider_Ncsrx {
  height : 2px;
  grid-column: 1 / span 1;
  grid-column: 1 / span var( --propertyGrid-columns, 1);
  grid-column: 1 / span calc( 2 * 1 );
  grid-column: 1 / span calc( 2 * var( --propertyGrid-columns, 1) );
  background : #eeeeee;
  margin : 0 calc( 16px * -1);
  margin : 0 calc( var( --size-padMedium, 16px ) * -1);
  width: 100%;
}


.hint_YpNlq {
  max-width: 300px;
  margin-bottom : 16px;
  margin-bottom : var( --size-padLarge, 16px )
}

.label_tmRF9 {
  display: inline-grid;
  -webkit-column-gap: 16px;
     -moz-column-gap: 16px;
          column-gap: 16px;
  -webkit-column-gap: var( --size-propertyGridColumnGap, var( --size-padMedium, 16px ));
     -moz-column-gap: var( --size-propertyGridColumnGap, var( --size-padMedium, 16px ));
          column-gap: var( --size-propertyGridColumnGap, var( --size-padMedium, 16px ));
  justify-self: left; /* VAR */
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  grid-auto-flow: column;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/PropertyGrid.css"],"names":[],"mappings":";;AAEA;EACE,cAAc;EACd,0CAAwE;EAAxE,wEAAwE;EACxE,sBAA8E;EAA9E,mFAA8E;EAA9E,yBAA8E;KAA9E,sBAA8E;UAA9E,iBAA8E;EAA9E,sFAA8E;KAA9E,mFAA8E;UAA9E,8EAA8E;EAC9E,mBAAwE;EAAxE,6EAAwE;EAAxE,cAAwE;EAAxE,wEAAwE;EACxE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;EACrB,gCAAmE;EAAnE,mEAAmE;AACrE;;AAEA;EACE,cAAc;EACd,sCAAoE;EAApE,oEAAoE;EACpE,sBAA8E;EAA9E,mFAA8E;EAA9E,yBAA8E;KAA9E,sBAA8E;UAA9E,iBAA8E;EAA9E,sFAA8E;KAA9E,mFAA8E;UAA9E,8EAA8E;EAC9E,mBAAuE;EAAvE,4EAAuE;EAAvE,cAAuE;EAAvE,uEAAuE;EACvE,wBAAkB;MAAlB,qBAAkB;UAAlB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;EACrB,cAAyE;EAAzE,yEAAyE;AAC3E;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,aAAiE;EAAjE,iEAAiE;AACnE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;;AAGA;EACE,wBAAwB;EACxB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAA2C;EAA3C,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,mCAAiE;EAAjE,iEAAiE;EACjE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAqD;EAArD,qDAAqD;EACrD,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAAqG;EAArG,qGAAqG;AACvG;;AAEA;EACE,cAAqC;EAArC;AACF;;AAEA;EACE,YAAY;EACZ,uBAAqD;EAArD,qDAAqD;EACrD,oBAAoB;EACpB,2BAAoD;EAApD,oDAAoD;EACpD,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,uBAAqD;EAArD,qDAAqD;EACrD,mCAAiE;EAAjE,iEAAiE;EACjE,oBAAoB;EACpB,2BAAoD;EAApD,oDAAoD;EACpD,WAAW;AACb;;;AAGA;EACE,gBAAgB;EAChB,oBAA2C;EAA3C;AACF;;AAEA;EACE,oBAAoB;EACpB,wBAA6E;KAA7E,qBAA6E;UAA7E,gBAA6E;EAA7E,qFAA6E;KAA7E,kFAA6E;UAA7E,6EAA6E;EAC7E,kBAAkB,EAAE,QAAQ;EAC5B,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,sBAAsB;AACxB","sourcesContent":["\n\n.gridHorizontal {\n  display : grid;\n  grid-template-columns: repeat(var( --propertyGrid-columns, 1), auto 1fr);\n  column-gap : var( --size-propertyGridColumnGap, var( --size-padMedium, 16px ));\n  row-gap : var( --size-propertyGridRowGap, var( --size-padMedium, 16px ));\n  align-items: center;\n  justify-items: start;\n  justify-content: left;\n  padding : var( --size-propertyGridPadding, --size-padMedium, 16px );\n}\n\n.gridVertical {\n  display : grid;\n  grid-template-columns: repeat(var( --propertyGrid-columns, 1), 1fr );\n  column-gap : var( --size-propertyGridColumnGap, var( --size-padMedium, 16px ));\n  row-gap : var( --size-propertyGridRowGap, var( --size-padLarge, 24px ));\n  align-items: start;\n  justify-items: start;\n  justify-content: left;\n  padding : var( --size-propertyGridPadding, var( --size-padMedium, 16px ));\n}\n\n.verticalCell {\n  display: inline-grid;\n  grid-template-columns: auto;\n  row-gap : var( --propertyGridRowGap, var( --size-padSmall, 8px ));\n}\n\n.gridHorizontal.inline, .gridVertical.inline {\n  display : inline-grid;\n}\n\n.gridHorizontal > .cell {\n  grid-column-end : span 2;\n  display: inline-block;\n}\n.gridVertical > .cell {\n  grid-column-end : span 1;\n  display: inline-block;\n}\n\n\n.gridHorizontal > .fillCell {\n  grid-column-end : span 2;\n  display: inline-flex;\n  align-items: center;\n}\n\n.gridVertical > .fillCell {\n  grid-column-end : span 1;\n  display: inline-flex;\n  align-items: center;\n  justify-self : stretch;\n}\n\n.fillCell > *:nth-child(2) {\n  margin-left : var( --size-padMedium, 16px );\n}\n\n.newRow {\n  grid-column-start: 1;\n}\n\n.gridHorizontal > .stretch {\n  display : grid;\n  justify-self: stretch;\n}\n\n.gridVertical > .stretch {\n  justify-self: stretch;\n}\n\n\n.gridHorizontal > .fill, .gridHorizontal > .header, .gridHorizontal > .subheader {\n  grid-column: 1 / span calc( 2 * var( --propertyGrid-columns, 1) ); \n  display : grid;\n  justify-self: stretch;\n}\n\n.gridVertical > .fill, .gridVertical > .header, .gridVertical > .subheader {\n  grid-column: 1 / span var( --propertyGrid-columns, 1); \n  display : grid;\n  justify-self: stretch;\n}\n\n.inset {\n  padding : var( --size-padMedium, 16px ) 0 var( --size-padMedium, 16px ) var( --size-padXLarge, 32px );\n}\n\n.pad {\n  padding : var( --size-padLarge, 16px )\n}\n\n.gridVertical > .divider {\n  height : 2px;\n  grid-column: 1 / span var( --propertyGrid-columns, 1);\n  background : #eeeeee;\n  margin : 0 calc( var( --size-padMedium, 16px ) * -1);\n  width: 100%;\n}\n\n.gridHorizontal > .divider {\n  height : 2px;\n  grid-column: 1 / span var( --propertyGrid-columns, 1);\n  grid-column: 1 / span calc( 2 * var( --propertyGrid-columns, 1) );\n  background : #eeeeee;\n  margin : 0 calc( var( --size-padMedium, 16px ) * -1);\n  width: 100%;\n}\n\n\n.hint {\n  max-width: 300px;\n  margin-bottom : var( --size-padLarge, 16px )\n}\n\n.label {\n  display: inline-grid;\n  column-gap: var( --size-propertyGridColumnGap, var( --size-padMedium, 16px ));\n  justify-self: left; /* VAR */\n  align-items: center;\n  grid-auto-flow: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridHorizontal": `gridHorizontal__wnhn`,
	"gridVertical": `gridVertical_Szvuz`,
	"verticalCell": `verticalCell_qBsf6`,
	"inline": `inline_RioVJ`,
	"cell": `cell_pO5_k`,
	"fillCell": `fillCell_ExsE8`,
	"newRow": `newRow_ziTPz`,
	"stretch": `stretch_qV3eb`,
	"fill": `fill_BFQjm`,
	"header": `header_nsuRL`,
	"subheader": `subheader_JyL8m`,
	"inset": `inset_dRjPx`,
	"pad": `pad_N5y3N`,
	"divider": `divider_Ncsrx`,
	"hint": `hint_YpNlq`,
	"label": `label_tmRF9`
};
export default ___CSS_LOADER_EXPORT___;
